/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestOtpModel } from '../../models/request-otp-model';
import { RequestOtpResponseModel } from '../../models/request-otp-response-model';

export interface LocalAccountRequestOtpPost$Params {
  
    /**
     * OTP request model containing email address
     */
    body?: RequestOtpModel
}

export function localAccountRequestOtpPost(http: HttpClient, rootUrl: string, params?: LocalAccountRequestOtpPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<RequestOtpResponseModel>> {
  const rb = new RequestBuilder(rootUrl, localAccountRequestOtpPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<RequestOtpResponseModel>;
    })
  );
}

localAccountRequestOtpPost.PATH = '/LocalAccount/RequestOTP';
